import React from "react";

export const IncomeExpenses = ({transactions }) => {

    const amounts = transactions.map(transaction => transaction.value);

    const income = amounts
    .filter(item => item > 0)
    .reduce((acc, item) => (acc += item), 0)
    .toFixed(2);

    const expense = (
        amounts.filter(item => item < 0).reduce((acc, item) => (acc += item), 0) * -1
    ).toFixed(2);

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <div className="inc-exp-container">
      <div>
        <h4>Income</h4>
        <p className="money plus">
          {numberWithCommas(income)}
        </p>
      </div>
      <div>
        <h4>Expense</h4>
        <p className="money minus">
          {numberWithCommas(expense)}
        </p>
      </div>
    </div>
  );
};
